import { render, staticRenderFns } from "./SelectEntitiesModalFacebook.vue?vue&type=template&id=05c464d7&scoped=true&"
import script from "./SelectEntitiesModalFacebook.vue?vue&type=script&lang=ts&"
export * from "./SelectEntitiesModalFacebook.vue?vue&type=script&lang=ts&"
import style0 from "./SelectEntitiesModalFacebook.vue?vue&type=style&index=0&id=05c464d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c464d7",
  null
  
)

export default component.exports